<div class="raptor-page-container" [formGroup]="form">
  <div style="display:none" [innerHTML]="stylesheet"></div>
  <open-raptor-progress [progress]="formData.progress" [pages]="formData.total_pages"></open-raptor-progress>
  <open-raptor-banner-header *ngIf="formData.settings?.banners" [data]="formData.settings?.banners"></open-raptor-banner-header>
  <div class="grid">
    <div class="cell margin-vertical-xsmall margin-right-medium margin-left-xmedium progress-nav">
      <button mat-icon-button color="primary" type="reset" [disabled]="raptorStepService.loading"><mat-icon>west</mat-icon></button>
    </div>
  </div>

  <div class="raptor-page-content">
    <div class="raptor-page-panel" [class]="raptorStepService.action" *ngIf="raptorStepService.stepReady">

      <div class="grid">
        <div class="raptor-page-main-panel cell cell-small-col-span-6 cell-large-col-span-12 cell-large-col-start-1">
          <header class="margin-bottom-xmedium padding-horizontal-medium">
            <h1 class="text-center" [ngClass]="{'margin-bottom-medium': formData.subtext}" *ngIf="formData.heading">{{ formData.heading }}</h1>
            <p class="text-center margin-bottom-none" *ngIf="formData.subtext">
              <mat-icon>pin_drop</mat-icon>
              {{ formData.subtext }}
            </p>
          </header>

          <div class="grid grid-wrapper margin-vertical-xxsmall">
            <div class="cell raptor-page-price-panel-length-1 cell-large-col-span-6 cell-large-col-start-4 cell-medium-col-span-6 cell-medium-col-start-2 cell-small-col-span-6 cell-small-col-start-1 cell-tiny-col-span-4 cell-tiny-col-start-1">
              <div class="raptor-page-price-frequency margin-bottom-xxsmall">
                <div class="raptor-page-price-frequency-panel">
                  <open-raptor-question *ngIf="frequencySwitchQuestion" [question]="frequencySwitchQuestion" [form]="form" [submitted]="true"></open-raptor-question>
                </div>
              </div>
            </div>
          </div>

          <!-- MAIN CONTENT -->
          <div class="raptor-page-price-container grid coverLength-1" *ngIf="cover">
            <div class="raptor-page-price-panel cell raptor-page-price-panel-length-1 cell-large-col-span-6 cell-large-col-start-4 cell-medium-col-span-4 cell-medium-col-start-3 cell-small-col-span-6 cell-small-col-start-1 cell-tiny-col-span-4 cell-tiny-col-start-1">

              <div class="raptor-page-price-content flex flex-column" [ngClass]="{'featured': cover.is_featured}">
                <div class="raptor-page-price-highlight">
                  <div class="raptor-page-price-highlight-panel">
                    <div class="text-small flex-grow" *ngIf="getCoverInfo(cover, 'description')">{{ getCoverInfo(cover, 'description') }}</div>

                    <div *ngIf="cover.banner" class="raptor-page-price-banner-box padding-top-xsmall">
                      <div *ngFor="let banner of cover.banner">
                        <div *ngIf="banner.tag" class="margin-bottom-xsmall raptor-page-price-banner">
                          {{ getTagLabel(banner) }}
                        </div>
                      </div>
                    </div>

                    <div class="text-left width-full">
                      <div class="text-center">
                        <open-price class="margin-bottom-small" *ngIf="!raptorStepService.updating" [price]="getCoverPrice(cover)" [precision]="2" class="margin-bottom-small" size="large"></open-price>
                        <h4 class="raptor-page-price-saving">
                          Save <open-price *ngIf="!raptorStepService.updating" [price]="getYearlyCoverSavings(cover)" [precision]="0" class="margin-bottom-small" size="small"></open-price> when you pay annually
                        </h4>
                        <div *ngIf="raptorStepService.updating" class="padding-top-small margin-bottom-small">
                          <mat-spinner diameter="50" class="price-spinner"></mat-spinner>
                        </div>
                      </div>
                      <div class="text-center text-xsmall" *ngIf="cover.has_additional_charges && cover.additionalChargesBanners" [ngClass]="{ 'featured': cover.is_featured }" [innerHTML]="cover.additionalChargesBanners.tag.annual"></div>
                    </div>

                    <div *ngIf="formData.data.device" class="raptor-price-page-device margin-vertical-small text-center text-small">
                      <p class="margin-none">{{ formData.human.device || formData.data.device }}</p>
                      <p>Your quote is valid for 30 days</p>
                    </div>
                  </div>

                  <div class="raptor-page-price-features text-left">
                    <div [innerHTML]="getCoverInfo(cover, 'covered_help').text"></div>
                  </div>

                  <div *ngIf="cover.features && cover.features.length" class="raptor-page-price-cover-features padding-small">
                    <mat-accordion *ngFor="let feature of cover.features" class="raptor-page-price-cover-features">
                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title><strong>{{ feature.heading }}</strong></mat-panel-title>
                        </mat-expansion-panel-header>
                        <div *ngFor="let item of feature.items" class="flex margin-bottom-xsmall">
                          <mat-icon [ngClass]="item.is_included ? '' : 'optional'">
                            {{ item.is_included ? 'check_circle_fill' : 'cancel' }}
                          </mat-icon>
                          <span class="padding-left-xxsmall flex-shrink" [innerHTML]="item.text"></span>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

          <div class="grid grid-wrapper margin-vertical-xxsmall" *ngIf="formData.cover_exclusions_info && formData.cover_exclusions_info.length">
            <div class="cell cell-large-col-span-10 cell-medium-col-span-6 cell-small-col-span-6 cell-large-col-start-2 cell-medium-col-start-2">
              <div class="open-form-info radius-ai padding-medium">
                <div *ngFor="let info of formData.cover_exclusions_info">
                  <b *ngIf="info.heading" class="margin-bottom-xsmall">{{ info.heading }}</b>
                  <p *ngIf="info.content">{{ info.content }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="raptor-page-column-container grid">
        <div
          class="raptor-page-column-content cell cell-small-col-span-6"
          [ngClass]="{
            'bg-block radius-block': formData.settings.card === true,
            'cell-large-col-span-12': formData.settings.size !== 'small' && formData.settings.size !== 'medium',
            'cell-large-col-span-8 cell-medium-col-span-6': formData.settings.size === 'medium',
            'cell-large-col-start-3 cell-medium-col-start-2': formData.settings.size === 'medium' && (!formData.settings.align || formData.settings.align === 'center'),
            'cell-large-col-start-5 cell-medium-col-start-3': formData.settings.size === 'medium' && formData.settings.align === 'right',
            'cell-large-col-span-6 cell-medium-col-span-4': formData.settings.size === 'small',
            'cell-large-col-start-4 cell-medium-col-start-3': formData.settings.size === 'small' && (!formData.settings.align || formData.settings.align === 'center'),
            'cell-large-col-start-1': formData.settings.size === 'small' && formData.settings.align === 'left',
            'cell-large-col-start-7 cell-medium-col-start-5': formData.settings.size === 'small' && formData.settings.align === 'right'
          }"
        >
          <div *ngFor="let section of formData.sections; index as i" class="form-row">
            <open-raptor-section *ngIf="i > 0" [section]="section" [form]="form"></open-raptor-section>
          </div>
        </div>
      </div>
    </div>

    <input type="hidden" formControlName="cover_level" id="cover_level" />
    <input type="hidden" formControlName="cover_type" id="cover_type" />
    <button type="submit" hidden id="coverSubmit">submit</button>
    <div class="page-price-select-cover text-center">
      <button mat-flat-button color="primary" type="button" (click)="selectCover(cover)" [disabled]="raptorStepService.loading">
        <span class="mdc-button__label" *ngIf="!raptorStepService.loading">Continue</span>
        <mat-spinner *ngIf="raptorStepService.loading" diameter="28"></mat-spinner>
      </button>
    </div>
  </div>

  <div class="raptor-prices-disclaimer" *ngIf="disclaimers && raptorStepService.stepReady">
    <div class="grid grid-wrapper mat-typography">
      <div class="raptor-prices-disclaimer-content cell cell-small-col-span-6 cell-large-col-span-12">
        <div *ngFor="let disclaimer of disclaimers">
          <div *ngIf="disclaimer.type === 'promotional'" class="raptor-page-price-banner-disclaimer margin-bottom-xsmall text-xsmall">
            {{ disclaimer.content }}
          </div>
          <!-- Showing extras banners below to list content -->
          <div *ngIf="disclaimer.type === 'additionalCharges'" class="raptor-page-price-banner-disclaimer margin-bottom-xsmall text-xsmall">
            {{ disclaimer.content }}
          </div>
        </div>
        <ul *ngIf="includedExtrasDisclaimers?.length">
          <li class="raptor-page-price-banner-disclaimer text-xsmall" *ngFor="let extrasDisclaimer of includedExtrasDisclaimers"><strong>{{ extrasDisclaimer.label }}:</strong> {{ extrasDisclaimer.disclaimer }}</li>
        </ul>
      </div>
    </div>
  </div>

  <div class="raptor-prices-disclaimer" *ngIf="formData.disclaimer && formData.disclaimer.content">
    <div class="grid grid-wrapper" *ngIf="raptorStepService.stepReady" ngClass="{'padding-top-big': !disclaimers || !disclaimers.length}">
      <div class="cell cell-small-col-span-6 cell-large-col-span-12">
        <p class="raptor-page-price-banner-disclaimer text-xsmall" [innerHTML]="formData.disclaimer.content"></p>
      </div>
    </div>
  </div>
</div>
